var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginpagedoctors02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366.259,
    height: 1153.137,
    viewBox: "0 0 366.259 1153.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 46.302,
    y1: -7.126,
    x2: 46.331,
    y2: -7.632,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#652f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.125,
    y1: -6.793,
    x2: 46.008,
    y2: -7.365,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 49.812,
    y1: -6.055,
    x2: 50.338,
    y2: -7.24,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#6b3227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#783b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 221.895,
    y1: -12.595,
    x2: 224.863,
    y2: -13.798,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 221.425,
    y1: -10.972,
    x2: 224.377,
    y2: -12.032,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfd3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#c1d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#cadaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0def6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.536,
    y1: 4.365,
    x2: 0.447,
    y2: -4.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#d6e2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e1f6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.498,
    cy: 0.485,
    r: 2.974,
    gradientTransform: "translate(0.897 21.69) scale(0.143 0.159)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#e9e8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#f7f6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefdfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f1c69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f4cea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -3.094,
    y1: -0.438,
    x2: 1.732,
    y2: 0.822,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd9b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.496,
    y1: 1.014,
    x2: 0.506,
    y2: 0.234,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0f0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0b0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.494,
    y1: 1.012,
    x2: 0.503,
    y2: 0.235,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.285,
    y1: 0.244,
    x2: 0.698,
    y2: 1.486,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 395.219,
    y1: -0.42,
    x2: 391.905,
    y2: 0.685,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -0.111,
    y1: 0.778,
    x2: 0.901,
    y2: -0.021,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.07,
    y1: 1.048,
    x2: 0.13,
    y2: -0.255,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.456,
    y1: 0.048,
    x2: 0.576,
    y2: 0.971,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.498,
    y1: -0.062,
    x2: 0.518,
    y2: 0.991,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.017,
    y1: -0.232,
    x2: 0.969,
    y2: 0.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5e2f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#dce7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#d6e2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e1f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.59,
    y1: 2.542,
    x2: 0.476,
    y2: -0.401,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.993,
    y1: 1.133,
    x2: 0.209,
    y2: -0.112,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -0.238,
    y1: 0.981,
    x2: 1.43,
    y2: 0.014,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.588,
    y1: -0.518,
    x2: 0.47,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.523,
    y1: -0.187,
    x2: 0.472,
    y2: 1.581,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.502,
    y1: -0.935,
    x2: 0.5,
    y2: 1.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#1c1c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.537,
    y1: -0.256,
    x2: 0.469,
    y2: 1.998,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.531,
    y1: -0.94,
    x2: 0.489,
    y2: 1.004,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.525,
    y1: -0.941,
    x2: 0.491,
    y2: 1.004,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -0.414,
    y1: 0.245,
    x2: 0.198,
    y2: 1.314,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -0.201,
    y1: 0.574,
    x2: 0.013,
    y2: 2.218,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#5c2b22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -0.753,
    y1: -3.317,
    x2: 0.064,
    y2: -1.124,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -5.837,
    y1: -1.247,
    x2: -5.819,
    y2: -1.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f5d1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f2c99f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -6.862,
    y1: -1.452,
    x2: -6.844,
    y2: -1.452,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.521,
    cy: 0.483,
    r: 0.445,
    gradientTransform: "matrix(-1.163, 0.229, -0.295, -1.051, -18.996, -5.398)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b38e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#f7c59e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -35.047,
    y1: -33.303,
    x2: -34.968,
    y2: -33.303,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.244,
    y1: 0.633,
    x2: -0.513,
    y2: 2.807,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -0.813,
    y1: 0.662,
    x2: 0.453,
    y2: 2.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#52271d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.464,
    cy: 0.501,
    r: 0.457,
    gradientTransform: "matrix(1.141, 0.216, 0.255, -0.986, 2.106, -6.884)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -25.257,
    y1: -36.154,
    x2: -25.179,
    y2: -36.154,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.432,
    y1: 0.878,
    x2: -2.352,
    y2: 2.899,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#683127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#52271d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#462117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -0.545,
    y1: 1.429,
    x2: 0.551,
    y2: 1.429,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7a3c31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1.15,
    y1: 0.657,
    x2: -1.234,
    y2: 1.418,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#6a3126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#74382d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -74.632,
    y1: 6.187,
    x2: -74.479,
    y2: 8.055,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.46,
    y1: 0.096,
    x2: 0.612,
    y2: 1.965,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -9.887,
    y1: 1.65,
    x2: -9.379,
    y2: 3.935,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#5a2b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#482219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -0.16,
    y1: 2.224,
    x2: -0.384,
    y2: 1.164,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -1.441,
    y1: 1.142,
    x2: -0.685,
    y2: -0.211,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#421f16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#482219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#5a2b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.455,
    y1: 1.14,
    x2: 0.406,
    y2: 0.173,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -36.555,
    y1: -0.051,
    x2: -36.409,
    y2: -0.051,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -48.694,
    y1: -9.623,
    x2: -48.539,
    y2: -9.623,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -8.874,
    y1: -19.938,
    x2: -8.833,
    y2: -19.938,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#efe4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#faf8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -8.411,
    y1: -12.514,
    x2: -8.375,
    y2: -12.514,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#ebdddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#f6f0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#fcfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fbf7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#f1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -8.78,
    y1: -8.496,
    x2: -8.743,
    y2: -8.496,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f96e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#f9707f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#fd7985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#ff7d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#fd7985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#f86d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f86d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -8.767,
    y1: -31.99,
    x2: -8.73,
    y2: -31.99,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#eadcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#f6efee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#fbf6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -11.791,
    y1: -56.653,
    x2: -11.742,
    y2: -56.653,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#52261c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#462017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#421f16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#462017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#52261c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 0.888,
    y1: 0.265,
    x2: 0.052,
    y2: 0.761,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dba379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -0.022,
    y1: 0.5,
    x2: 0.978,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#f5f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ece7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.302,
    y1: 0.5,
    x2: 0.821,
    y2: 0.5,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1.284,
    y1: 1.341,
    x2: 0.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b89c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715241"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 2.276,
    y1: 3.296,
    x2: 0.925,
    y2: 1.276,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.36,
    cy: 0.558,
    r: 0.595,
    gradientTransform: "translate(0.017) scale(0.967 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -0.006,
    y1: 0.5,
    x2: 0.994,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#391b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#3d1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a2a1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 0.399,
    y1: 0.127,
    x2: 1.095,
    y2: 3.452,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 0.503,
    y1: 1.439,
    x2: 0.5,
    y2: -0.041,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 14.355,
    y1: -15.088,
    x2: 13.937,
    y2: -17.141,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.949,
    y1: 0.216,
    x2: 0.027,
    y2: 1.233,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.058,
    y1: 0.22,
    x2: 0.989,
    y2: 1.259,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 0.957,
    y1: 0.256,
    x2: -0.002,
    y2: 0.826,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1.122,
    y1: 1.02,
    x2: -0.114,
    y2: -0.131,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 2.197,
    y1: 1.127,
    x2: 0.549,
    y2: 0.581,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.36,
    cy: 0.558,
    r: 0.595,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -0.006,
    y1: 0.5,
    x2: 0.994,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a2a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#3d1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391b13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 0.566,
    y1: 0.325,
    x2: -0.455,
    y2: 4.688,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 8.801,
    y1: 1.397,
    x2: 9.526,
    y2: 1.397,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#fcd7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 0.507,
    y1: 0.454,
    x2: 0.576,
    y2: 4.619,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -16.877,
    y1: -20.037,
    x2: -16.83,
    y2: -20.037,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -0.471,
    y1: -1.954,
    x2: -0.466,
    y2: -2.743,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0a0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 0.378,
    y1: 0.006,
    x2: 0.565,
    y2: 0.879,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0.523,
    y1: 1.107,
    x2: 0.407,
    y2: -1.217,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 0.738,
    y1: -0.051,
    x2: 0.424,
    y2: 0.918,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 0.521,
    y1: 1.1,
    x2: 0.402,
    y2: -1.343,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 0.47,
    y1: 1.043,
    x2: 0.538,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -0.556,
    y1: 1.387,
    x2: 1.1,
    y2: -0.451,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 0.739,
    y1: 1.041,
    x2: 0.809,
    y2: 0.027,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 5.408,
    y1: -0.226,
    x2: 5.353,
    y2: 1.77,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#f8f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1.064,
    y1: 1.376,
    x2: -0.097,
    y2: -0.178,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 0.514,
    y1: -0.076,
    x2: 0.466,
    y2: 1.852,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -0.052,
    y1: 0.899,
    x2: 1.429,
    y2: -0.139,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 0.179,
    y1: -0.025,
    x2: 0.944,
    y2: 1.205,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 0.05,
    y1: -0.051,
    x2: 0.876,
    y2: 1.223,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1.385,
    y1: 1.79,
    x2: -0.023,
    y2: 1.643,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -39.002,
    y1: 17.992,
    x2: -36.881,
    y2: 18.312,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -0.061,
    y1: 1.65,
    x2: 0.984,
    y2: 1.786,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 0.266,
    y1: 0.312,
    x2: 0.032,
    y2: 2.028,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1.036,
    y1: 1.777,
    x2: -0.173,
    y2: 0.949,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -0.362,
    y1: 0.261,
    x2: 0.152,
    y2: 1.335,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -0.196,
    y1: 1.392,
    x2: 0.886,
    y2: 1.205,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -0.38,
    y1: 0.21,
    x2: 0.893,
    y2: 1.452,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -7.666,
    y1: -1.027,
    x2: -8.578,
    y2: 0.155,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7aaab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#b7babb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#cbcdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d0d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7aaab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -4.582,
    y1: -0.746,
    x2: -3.785,
    y2: -0.746,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -3.156,
    y1: 0.002,
    x2: -2.972,
    y2: 0.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c3c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcece"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -4.002,
    y1: 0.477,
    x2: -3.002,
    y2: 0.477,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddfe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -6.105,
    y1: -0.023,
    x2: -5.712,
    y2: 1.443,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -7.186,
    y1: 0.037,
    x2: -7.139,
    y2: 1.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#eceded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 0.557,
    y1: 1.73,
    x2: 0.437,
    y2: -0.553,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#fdfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 0.56,
    y1: 1.734,
    x2: 0.436,
    y2: -0.541,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -39.509,
    y1: 4.559,
    x2: -38.09,
    y2: 3.265,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#f5d0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#f1c69c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c69c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -45.982,
    y1: 12.898,
    x2: -43.999,
    y2: 13.127,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 0.935,
    y1: 1.678,
    x2: -0.057,
    y2: 0.918,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -120.573,
    y1: 9.948,
    x2: -118.907,
    y2: 10.003,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -89.773,
    y1: 24.172,
    x2: -87.766,
    y2: 24.393,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -89.26,
    y1: 33.439,
    x2: -87.193,
    y2: 33.757,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -56.719,
    y1: 11.508,
    x2: -54.746,
    y2: 11.67,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -0.902,
    y1: 1.823,
    x2: 0.265,
    y2: 1.475,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1.583,
    y1: 0.688,
    x2: -0.102,
    y2: 1.304,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: -176.599,
    y1: 19.261,
    x2: -176.316,
    y2: 19.708,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c69c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -262.475,
    y1: 20.692,
    x2: -263.881,
    y2: 19.781,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -114.534,
    y1: 17.845,
    x2: -114.61,
    y2: 18.112,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -250.421,
    y1: 26.046,
    x2: -251.596,
    y2: 25.033,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -117.772,
    y1: 23.342,
    x2: -117.407,
    y2: 23.685,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -150.143,
    y1: 17.569,
    x2: -151.378,
    y2: 16.843,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -162.471,
    y1: 47.432,
    x2: -162.374,
    y2: 48.089,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 0.499,
    y1: 0.295,
    x2: -0.074,
    y2: 1.532,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 0.445,
    y1: 2.066,
    x2: 0.475,
    y2: 0.792,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 0.612,
    y1: 0.663,
    x2: 1.132,
    y2: 1.733,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 0.587,
    y1: 0.424,
    x2: -0.437,
    y2: 1.325,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login_page_doctors_02",
    "data-name": "login page doctors 02",
    transform: "translate(-376.729 -976.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M481.51,1763.662l65.123-.972-.1-47.406-72.094,5.524Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M536.454,1089.009c9.273-14.319,57.807-10.771,23.227,48.843-24.8,42.755-77.509,27.876-63.8,3.079C509.506,1116.291,527.186,1103.326,536.454,1089.009Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M558.173,1138.973c-3.116,3.615-10.3,28.7-34.717,28.847-15.354.091-26.961-6.962-28.752-13.96,0,0,8.6,5.486,16.929,2.958s14.881-34.3,14.881-34.3,4.032,22.96,5.939,21.386,2.966-45.779,9.929-51.72,14.482-11.5,21.12-7.354S584.5,1108.437,558.173,1138.973Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M561.881,1084.009s19.019,7.983,11.835,33.385c-3.129,11.067-12.327,17.974-14.737,22.091s-3.357,19.9-23.743,28.584c-10.67,4.547-21.13,2.544-32.62-5.341,0,0,17.765,9.573,37.446-2.888,11.91-7.548,13.516-16.7,16.7-21.933s14.291-11.215,16.06-30.612C574.075,1093.482,561.881,1084.009,561.881,1084.009Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M546.249,1112.975s28.331,24.794-4.889,48.575C541.36,1161.55,564.8,1143.012,546.249,1112.975Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M542.134,1110.561s9.134,14.924,8.9,25.479-2.833,21.551-16.231,29.667c0,0,11.8-8.8,12.524-27.266C547.725,1128.093,542.134,1110.561,542.134,1110.561Z",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M437.5,1182s4.387-21.8,32.259-26.258c33.005-5.278,81.023-6,87.025,17.255S437.5,1182,437.5,1182Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M453,1165.245c-10.656,5.536-2.236-2.08-5-1.25,0,0,19.958-13.506,51.516-13.254,31.256.25,52.345,9.646,53.265,14.754-.2-1.134-.119.969-1.975.612-2.171-.417-6.53-3.275-10.029-4.613-10.558-4.036-26.99-6.038-39.512-5.5C479.747,1156.915,472.257,1155.243,453,1165.245Z",
    fill: "#fcfefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M449.534,1179.249c-.266-1.327,7.179-10.579,9.452-11.261,43.35-13.005,75.534-4.133,81.107.91s12.155,28.9,12.155,28.9l-98.2,2.389Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M457.438,1168.9s7.373-7.642,42.871-7.995c18.972-.189,37.86,2.5,42.233,7.995l1.123,9.909s4.245-17.34-42.466-15.925c-37.139,1.126-41.355,8.492-46.358,14.509Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 177.32,
    cy: 25.333,
    rx: 177.32,
    ry: 25.333,
    transform: "translate(388.347 2079.246)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M418.876,1707.426s9.566,52.76,7.972,72.545-4.425,75.475.179,94.527,46.751,128.923,46.853,134.83c.169,9.81,1,26.837,1,26.837l-2.591,61.828,41.8-1.908s1.423-29.038.453-34.09c-4.957-25.83-19.591-89.191-19.591-89.191s-2.255-96.209-4.646-112.33-7.649-43.865-7.649-48.262,4.993-25.507,5.58-32.241c1.16-13.286-.8-68.34-.8-68.34Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M514.629,1699.366s20.418,64.706,21.939,71.3,10.955,36.071,15.536,46.833c2.04,4.793,14.988,24.17,16.509,30.032s10.842,55.627,16.924,71.015,33.249,69.53,34.009,82.72.538,33.083.538,33.083l15.872,57.766h41.282l-23.48-65.935s-10.457-42.468-12.164-76.941c-.218-4.391-3.317-49.342-11.4-85-6.17-27.2-23.568-63.018-26.61-76.208s-5.322-97.458-5.322-97.458Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M616.3,1989.064c-9.655-24-30.678-62.083-35.124-79.315s-13.861-61.922-15.45-65.122-14-23.1-18.141-36.214-20.54-69.4-20.54-69.4l72.517-8.587,1.342,27.4s-18.689,7.958-54.267,4.86c0,0,13.621,54.423,26.248,68.582C577.039,1835.933,588.279,1908.547,616.3,1989.064Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M488.269,1744.659s1.447,26.8,0,36.835c-.224,1.556-5.8,28.8-5.412,32s9.385,47.4,9.753,52.01,1.452,99.541,3.59,109.379,17.8,84.347,17.8,84.347l-25.008-83.277-6.362-115.815s-8.8-48.45-9.161-50.109-2.527-45.463-2.527-45.463-29.3,1.638-44.615-3.661l-2.677-21.891Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M425.1,1810.709s-3.19,48.306.657,62.375,42.307,117.911,42.307,117.911-32.5-119.9-33.22-122.557S425.1,1810.709,425.1,1810.709Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M604.434,1791.152s22.189,54.324,27.4,73.47c6.286,23.114,11.166,104.113,13.045,115.759s8.883,45.8,8.883,45.8l5.468,15.355s-9.761-16.69-11.6-20.118-6.886-41.922-6.886-41.922-16.985-109.622-17.444-115.649S604.434,1791.152,604.434,1791.152Z",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M474.79,2034.35l-3.729,62.178,43.02-.443.453-34.09-5.447,28.117s-32.49.664-32.731,0S474.79,2034.35,474.79,2034.35Z",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M474.79,2034.35s-2.876,15.265-3.849,26.891-6.776,44.352-4.02,49.446,15.933,14.269,29.51,13.4c6.955-.446,19.962-9.33,21.621-13.729,1.793-4.754-1.444-32.024-3.518-48.36l-.915,30.787-41.187.6S476.412,2056.411,474.79,2034.35Z",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M620.091,2021.418l1.141,21.572,14.231,51.989,43.382-1.327-19.619-52.116,12.2,46.715-32.285.312S622.393,2038.784,620.091,2021.418Z",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M659.226,2041.536l17.156,50.053-40.485-.137s-8.282-33.1-8.9-35.252c-4.3-14.911-5.707-20.345-6.9-34.782,0,0-2.689,15.269-2.417,17.424,1.094,8.648,6.3,14.125,8.78,32.013s3.008,36.135,5.078,38.025c5.361,4.893,36.216,12.056,47.428,11.411,7.7-.443,3.318-19.719,1.263-27.639C677.887,2083.644,659.226,2041.536,659.226,2041.536Z",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M600.709,1198.439c-4.2-8.753-24.373-14.244-26.849-14.486-8.667-.835-43.735-3.576-47.354-15.148-4.5-14.4.869-32.854.869-32.854l-54.075-2.706c6.083,10.14,5.859,20.931,5.605,31.868-.278,12.012-36.649,20.477-49.145,21.857-6.834.754-30.927,8.7-34.251,20.456-4.672,16.516-4.309,22.03-2.92,43.717l217.619-20.857C608.876,1218.215,608.723,1215.138,600.709,1198.439Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M553.084,1181.912a43.068,43.068,0,0,0,5.611-3.023c-21.011-2.722-27.346-6.305-28.863-7.339-1.622-1.106-3.182-6.342-3.763-12.464-.252-2.663-.643-9.349-.734-12.838-.736.9-46.827-.777-48.607-3.4l-5.355.05s1.579,16.956-.932,29.1c-.511,2.473-15.445,5.975-25.25,8.017.7.544,3.217,2.239,3.781,2.538,8.391.827,15.608,1.812,19.034,1.218,4.189-.726,11.239-3.925,16.339-6.264,27.64-12.667,36.263-16.853,36.263-16.853,1.3,11.779,10.006,19.569,9.534,19.455C537.095,1181.8,545.566,1182.118,553.084,1181.912Z",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M509.057,1199.028s-2.877-7.921-12.559-4.841C496.5,1194.187,506.442,1195.947,509.057,1199.028Z",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M509.395,1192.255s2.776-7.192,6.645-8.151,46.676-2.4,51.689-3.374c0,0-19.048,4.162-30.059,5.441S518.025,1185.531,509.395,1192.255Z",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M495.722,1192.19s-2.678-5.513-7.44-7.115-41.143-3.854-47.691-3.214C440.591,1181.861,486.5,1186.464,495.722,1192.19Z",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M471.5,1164.31s-.641-23.478-1.614-28.687c0,0,54.191,1.953,56.651,2.17a105.157,105.157,0,0,0-1.063,13.69S503.242,1174.4,471.5,1164.31Z",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M483.53,1209.8s5.3-5.344,16.576,10.391c8.572,11.965,10.479,103.575,11,112.723,1.594,27.867-2,71.254-2,71.254l-31.267,1.088s-22.468-202.921-24.589-205.575l11.146-9.555Z",
    fill: "#d4e1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M457.523,1177.178l5.591-1.547s4.1,7.055,8.412,10.253A258.13,258.13,0,0,1,491.8,1204.06a107.466,107.466,0,0,1,8.634,11.512s16.86-17.477,19.556-20.015c4.791-4.508,12.029-11.6,16.542-21.106,0,0,5.091,1.452,6.015,1.632,0,0-23.075,27.207-23.961,29.129s-19.664,21.675-19.664,21.675S458.569,1182.672,457.523,1177.178Z",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M519.153,1206.154s-13.554,6.692-19.047,14.041c-3.866,5.172-.825,181.157-.825,181.157s38.752,14.138,44.592-2.317,8.815-203.6,14.477-206.251l-16.632-10.615Z",
    fill: "#d4e1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M483.182,1203.355l16.924,16.84,4.077,176.245-12.453.647s-4.156-153.074-4.931-157.283Z",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M480.334,1320.027c.707.093,34.589,1.9,36.088,1.2v10.117l-35.593-3.756Z",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M456.253,1210.008l4-5.5s19.592,67.047,20.005,70.02c2.122,15.271,9.311,77.024,5.387,126.826h-6.023Z",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M540.277,1201.505s-21.725,56.086-26.4,85.648c-7.513,47.523-1.351,121.15-1.351,121.15l12.19,3.733L545.433,1201.1Z",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M479.761,1389.65s29.471-2.056,38.707-3.037l1.4,10.474s-36.081,1.555-41.967-2.467Z",
    fill: "#bfd3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M599.82,1643.446c-.158-69.932-8.407-127.343-15.3-177.018-2.053-14.786-13.225-49.964-16.122-73.533-84.489,11.277-138.677-7.24-154.978-14.59l-.008.015c-31.318,59.405-31,90.992-28.885,134.124.626,12.742,12.166,144.029,12.389,151.322.5,16.417,0,76.1,0,76.1,7.08,9.734,45.066,13.933,53.1,14.016,12.226.126,63.815-.013,112.854-3.143,31.2-1.991,37.457-7.619,37.457-7.619C600.936,1725.472,599.979,1713.8,599.82,1643.446Z",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M414.375,1435.866c6.4-3.5,76.562,287.972,61.3,296.6s-57.718,3.9-58.381-6.722S379.2,1455.113,414.375,1435.866Z",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M472.435,1393.516s15.381,2.166,27.018,2.53,23.109.282,29.493-.543l1.112,26.293s-33.292,2.355-60.3-2.355Z",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M527.464,1729.394c4.314,11.615,58.366,7.633,58.073,0-.537-14-11.212-217.867-20.5-228.486S522.184,1715.179,527.464,1729.394Z",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M539.453,1752.019s-23.881-282.346-24.127-289.41-3.811-66.194-3.811-66.194,6.184-.092,14.553-.52l30.153,355.252Z",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M456.253,1753.915s29.151-340.34,29.821-358.784c0,0-10.527-.48-17.25-2.016l-39.54,358.506A172.084,172.084,0,0,0,456.253,1753.915Z",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M558.7,1178.889l47.286,12.441-14.97,76.458-17.042,124.793s29.906,165.3,32.012,180.454,13.879,183.943,13.879,183.943-20.148,16.89-70.448,15.413c0,0-30.831-293.3-35.441-434.691C513.153,1312.6,558.7,1178.889,558.7,1178.889Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M398.77,1196.4l45.718-20.216,30.068,110.972s9.33,49.352,9.426,61.78-35.818,375.324-39.494,423.458c-47.924-5.645-59.7-12.291-65-15.413,0,0-3.038-183.325-2.743-192.561s7.605-114.007,9.272-120.518c8.567-33.466,23.687-70.57,23.687-70.57C424.079,1266.649,398.77,1196.4,398.77,1196.4Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M577.574,1240.594s-2.263,14.28-3.294,23.436c-2.513,22.3-1.845,37.671-3.343,46.347,0,0,9.894-10.971,10.236-13.812S581.705,1203.654,577.574,1240.594Z",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M563.528,1083.966c3.659-14.495,16.159-83.81-38.938-95.553-24.479-5.221-59.581,157.463,1.27,142.513C535.981,1128.44,556.7,1115.292,563.528,1083.966Z",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M447.26,1053.991s-18.014,14.206-21.209,28.651c.173.711,8.83,29.257,31.042,38,26.181,10.3,36.55-2.762,61.056-13.373C518.149,1107.265,458.918,1065.425,447.26,1053.991Z",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M508.127,1009.211c-34.874-5.253-61.2,22.733-66.584,61.524-4.765,34.349.868,49.242,19.844,64.307,12.108,9.614,24.651,24.483,37.285,24.622,17.308.192,26.325-14.623,31.03-18.666,13.45-11.57,32.76-18.67,26.327-65.511C551.225,1040.548,537.652,1008.671,508.127,1009.211Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M494.275,1100.535c-2.71-15.332-.056-41.982-28.569-44.272-8.021-.644-13.837,2.878-17.854,6.42-9.354,8.245-3.6,28.826-3.6,28.826S463.055,1114.926,494.275,1100.535Z",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M502.685,1100.09c2.355-14.34,1.9-39.5,27.516-42.363,7.993-.893,14.066.518,18.267,3.483,11.3,7.978,6.372,27.378,6.372,27.378S534.175,1112.005,502.685,1100.09Z",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M556.846,1093.04s3.382-70.945-45.128-86.441c0,0-38.943-10.322-56.334,18.8-16.74,28.03-13.691,57.314-15.655,78.284,0,0,3.254-4.624,5.2-19.094a72.138,72.138,0,0,1,22.723-44.093c8.943-7.422,22.365-22.246,41.666-27.512,5.215-.449,16.477,2.5,25.507,17.279C550.009,1055.141,545.482,1069.321,556.846,1093.04Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M518.376,1105.739c2.2,10.133,8.76,18.719,17.487,22.084,11.4,4.4,19.32-10.911,20.892-29.682.865-10.327-13.645-17.623-22.715-15.479S516.188,1095.61,518.376,1105.739Z",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M544.92,1091.872c-3.08.883-5.2,3.013-4.745,4.763s3.327,2.461,6.4,1.581,5.2-3.009,4.745-4.763S547.992,1090.991,544.92,1091.872Z",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M505.368,1006.618c19.322-3.07,25.728-12.768,19.312-18.168-23.551-19.814-82.806-16.635-101.786,46.54-4.754,21.911.121,43.855,4.054,55.848,1.286-5.563,7.33-14.619,11.776-21.927,6.683-10.982,17.1-23.292,17.1-23.292C471.315,1026.094,490.77,1014.529,505.368,1006.618Z",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M508.073,1006.467a45.225,45.225,0,0,1,9.782-.8c6,.463,19.619,8.2,30.415,31.158,6.278,13.341,8.4,27.887,14.584,45.269-9.02,16.86-6.141-8.527-10.27-22.7-2.417-8.3-5.15-19.138-15.055-33.324C533.406,1020.158,523.675,1007.187,508.073,1006.467Z",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M478.962,1106.807c-1.932,8.755-7.688,24.43-16.221,23.3-11.015-1.457-19.389-7.523-20.235-28.765-.36-9,12.661-15.771,21.036-13.758S480.895,1098.042,478.962,1106.807Z",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M452.1,1094.4c-3.116-.551-5.875.441-6.164,2.209s2,3.658,5.118,4.216,5.875-.442,6.165-2.211S455.22,1094.952,452.1,1094.4Z",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M509.865,1006.194s-16.422,1.814-46.838,31.913c-5.613,5.553-16.689,15.1-27.1,44.395-.449-1.732-5.4,4.687-5.28,2.353,1.156-22.374,18.617-44.011,31.475-55.556C476.532,1016.362,499.084,997.513,509.865,1006.194Z",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M423.749,1066.586a62.155,62.155,0,0,1,2.259-17.941,73.469,73.469,0,0,1,24.914-38.031c14.271-11.423,30.723-16.37,41.789-15.007a26.354,26.354,0,0,1,16.032,8.005c-.08-.093-5.84-4.617-18.882-2.372-10.215,1.757-19.295,8.79-31.36,18.168a107.545,107.545,0,0,0-26.771,30.244A109.042,109.042,0,0,0,423.749,1066.586Z",
    fill: "url(#linear-gradient-43)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M445.623,1143.107c-.27.2.668-6.47-2.256-15.666-1.527-4.587-4.646-9.049-8.819-14.568-4.153-5.4-8.605-13.433-9.337-22.552a44.46,44.46,0,0,1,4.178-24.156,66.313,66.313,0,0,1,10.875-15.452,129.822,129.822,0,0,1,12.256-11.676,144.833,144.833,0,0,0-10.356,14.983c-5.135,8.685-10.17,20.276-8.608,34.52a43.62,43.62,0,0,0,6.063,18.818c3.257,5.728,6.647,11.917,7.5,17.666C448.79,1136.538,445.278,1143.027,445.623,1143.107Z",
    fill: "url(#linear-gradient-44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M556.312,1083.622c-2.238,17.759-2.877,31.272-2.877,31.272,7.279,0,8.71-7.613,11.554-14.323,4.347-10.257,6.912-21.256-2.983-21.845C560.077,1078.612,556.312,1083.622,556.312,1083.622Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M557.634,1108.922s3.564-3.934,2.458-11.671c-2.6-18.26,9.258-19.51,6.564-7.047,0,0-1.639-5.877-3.141-4.121-1.844,2.16,1.98,3.349.026,12.775C562.525,1103.755,557.634,1108.922,557.634,1108.922Z",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M441.638,1083.651c2.239,17.76,2.877,31.272,2.877,31.272-7.278,0-8.71-7.613-11.553-14.322-4.347-10.258-6.7-21.3,4.747-22.273C439.635,1078.165,441.638,1083.651,441.638,1083.651Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M440.317,1108.951s-3.564-3.934-2.458-11.671c2.6-18.26-9.258-19.51-6.565-7.047,0,0,1.64-5.877,3.141-4.121,1.845,2.16-1.979,3.349-.026,12.775C435.426,1103.784,440.317,1108.951,440.317,1108.951Z",
    fill: "url(#linear-gradient-46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M552.852,1060.248s2.281,26.941,3.981,33.689l.886-12.023S554.609,1063.736,552.852,1060.248Z",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M564.373,1067.778a83.2,83.2,0,0,1-6.006-12.269c-3.4-7.805-7.379-19.009-13.2-30.354-5.57-11.34-12.644-19.783-20.336-21.5a25.227,25.227,0,0,0-13.469.317c.3-.084,4.365-3.409,13.38-3.778a25.555,25.555,0,0,1,15.06,5.029c5.016,3.592,9.246,8.965,12.425,14.973,6.3,11.95,8.418,24.2,9.9,32.987C563.431,1062.03,564.292,1067.7,564.373,1067.778Z",
    fill: "url(#linear-gradient-48)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M444.515,1062.535s-2.319,23.281-4.021,31.4l-.942-14.343L442,1067.336Z",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M422.845,1035.221c4.291-20.652,19.406-37.875,29.419-45.012,24.38-17.379,53.407-15.441,72.5-7.912,36.587,14.43,40.6,48.91,40.6,48.91s-18.282-39.531-51.586-44.514c-7.811-1.169-29.481-2.445-49.116,4.789C443.594,999.242,430.366,1016.905,422.845,1035.221Z",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M471.251,1120.454c-1.462-.49-2.277-1.662-1.668-2.784.54-1,6.7,3.351,9.066,6.761A27.085,27.085,0,0,0,471.251,1120.454Z",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M525.89,1119.988c1.425-.6,2.153-1.823,1.46-2.9-.61-.96-6.434,3.826-8.544,7.4A27.01,27.01,0,0,1,525.89,1119.988Z",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M484.358,1131.95c2.766,5.912,17.969,14.146,29.191-.148C513.549,1131.8,497.61,1138.928,484.358,1131.95Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M497.2,1121.838a115.792,115.792,0,0,1-26.051-3.038l-.006.033a3.805,3.805,0,0,1,.249.36,28.747,28.747,0,0,1,6.5,3.22c1.81,1.306,3.59,10.114,21.4,9.91,9.727-.114,15.6-3.438,21.339-10.1a15.408,15.408,0,0,1,4.915-3.55c.035-.163.114-.234.155-.4C521.792,1119.381,513.968,1122.023,497.2,1121.838Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M513.236,1123.4c-9.989,2.257-23.587,1.985-28.511,1.086-2.865-1.264-2.58,2.372-2.58,2.372,6.263,6.416,11.29,5.206,16.327,5.327,4.968.133,12.388-1.877,16.791-5.8C515.69,1125.2,514.629,1123.086,513.236,1123.4Z",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M517.664,1119.693s-3.258,1.589-10.911,2.4c-7.723.822-10.977.359-17.915.033a44.138,44.138,0,0,1-9.121-1.56,9.852,9.852,0,0,1,1.208,1.985c.609,1.4,3.623,6.133,17.959,5.95,10.785-.14,16.466-3.984,17.23-6.312C516.578,1120.791,517.579,1120.168,517.664,1119.693Z",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M500.24,1131.67c-21.9-.012-14.292-8.961-28.852-12.477a27,27,0,0,1,7.188,6.211c4.235,4.888,7.884,12.591,20.155,12.483,11.072-.111,17.169-8.175,20.7-12.6,4.044-5.068,6.063-6.582,6.154-6.606C513.7,1121.931,517.644,1131.115,500.24,1131.67Z",
    fill: "#f86d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M487.281,1129.658c-3.369-1.725-6.375-5.394-7.007-5.861.793,1.073,5.543,12.672,17.874,12.4,14.259-.318,16.825-9.891,19.37-12.737-1.2,1.269-4.221,4.686-7.941,5.972a41.607,41.607,0,0,1-11.18,2.063A29.943,29.943,0,0,1,487.281,1129.658Z",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M509.149,1130.86c.185.5-1.182,2.163-4.087,2.977-3.737,1.054-6.7.049-6.89-.454s4.769-.851,6.208-1.351S508.959,1130.362,509.149,1130.86Z",
    fill: "#ff9aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M471.624,1120.042c.87.394,1.535-.265,4.97.98,0,0-5.853-3.045-6.239-2.871C470.085,1118.272,470.345,1119.458,471.624,1120.042Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M525.6,1119.543c-.858.414-1.818-.216-4.815,1.131,0,0,5.569-3.369,6.047-3.047C527.08,1117.794,526.871,1118.935,525.6,1119.543Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M480.023,1120.912l.93,1.7s6.207,3.332,18.942,3.283a39.853,39.853,0,0,0,16.164-3.542l.726-1.7Z",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M506.807,1119.655c-4.257-.331-4.732.367-7.787.394-2.986.027-5.376-.844-9.065-.512a57.824,57.824,0,0,1-17.634-.638s2.589,1.59,15.426,4.063a50.756,50.756,0,0,0,11.14,1.372c4.7.021,8.593-.96,12.235-1.58a61.643,61.643,0,0,0,13.493-4.258C521.324,1119.428,511.508,1120.011,506.807,1119.655Z",
    fill: "#f86d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M484.871,1120.914c.122-.447,6.5-1.009,7.544-1.008s4.538.612,5.8.616a50.317,50.317,0,0,0,6.149-.471c1.045-.238,8.8.441,8.725.981s-11.317,1.9-12.643,2.02S484.518,1122.237,484.871,1120.914Z",
    fill: "url(#linear-gradient-57)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M530.428,1057.768s8.248-1.627,18.814,5.089c6.148,3.909.824,20.015.824,20.015S553.514,1062.857,530.428,1057.768Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M519.341,1059.186c-4.3,2.04-7.386,7.757-3.651,6.517s17.528-6.519,20.544-6.593c4.682-.1,11.591,2.371,13.416,3.511,0,0-8.367-6.553-13.524-7.081C530.986,1055.007,521.655,1058.089,519.341,1059.186Z",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M477.676,1059.347c-2.361-.984-12.557-4.1-17.667-3.325s-13.175,7.834-13.175,7.834c1.768-1.224,8.971-4.378,13.238-4.254,3.01.083,17.04,4.651,20.825,5.713S482.072,1061.182,477.676,1059.347Z",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M463.889,1068.182c-4.323.358-13.513,1.929-13.4,10.06.148,10.278,10.845,12.722,15.623,12.762,6.07.059,10.282-1.72,13.873-2.829,2.66-.821,4.086-1.082,5.438-1.384C485.058,1078.9,481.784,1068.182,463.889,1068.182Z",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M474.5,1074.4c1.8,1.677,3.921,4.71,4.064,7.488.158,3.211-1.061,4.974-3.175,6.921,2.713-.734,5.321-2.073,9.23-2.63C484.617,1086.176,480.832,1078.139,474.5,1074.4Z",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M475.021,1075.564A8.851,8.851,0,0,1,478.4,1081a30.91,30.91,0,0,1,6.22,5.175S480.816,1078.381,475.021,1075.564Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M467.116,1072.769c-4.409.393-9.762,2.647-16.22,8.007,0,0,3.677,7.711,14.13,9.071-2.445-1.619-4.2-3.71-4.375-7.049A9.957,9.957,0,0,1,467.116,1072.769Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M478.418,1080.771a20.124,20.124,0,0,0-17.994-2.486,9.489,9.489,0,0,0-.938,4.722c.189,3.235,2.041,5.248,4.6,6.826,4.009.666,10.559-.669,11.3-1.027,2.205-1.874,3.409-3.813,3.175-6.921A10.2,10.2,0,0,0,478.418,1080.771Z",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M452.582,1081.035l1.24,2.274a26.471,26.471,0,0,1,6.065-3.506,8.977,8.977,0,0,1,4.225-5.055C459.468,1075.612,455.129,1077.806,452.582,1081.035Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M475.021,1075.564a9.906,9.906,0,0,0-2.491-.852,22.957,22.957,0,0,0-8.418.036,8.737,8.737,0,0,0-4.278,5.077,20.658,20.658,0,0,1,9.741-1.69,21.074,21.074,0,0,1,8.883,2.866A8.68,8.68,0,0,0,475.021,1075.564Z",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M468.746,1075.32a5.808,5.808,0,1,0,6.42,5.34A5.908,5.908,0,0,0,468.746,1075.32Z",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M470.418,1078.88a1.631,1.631,0,0,0-2.2.782,1.713,1.713,0,0,0,.717,2.277,1.631,1.631,0,0,0,2.2-.785A1.714,1.714,0,0,0,470.418,1078.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M475.907,1081.164a2.262,2.262,0,0,0-3.029.989,2.225,2.225,0,0,0,1.021,2.995,2.274,2.274,0,0,0,3.035-.994A2.22,2.22,0,0,0,475.907,1081.164Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M457.473,1073.124a12.49,12.49,0,0,1-10.613.319c.042.236-.742,6.527,3.859,8.125a6.122,6.122,0,0,0,.156.663,3.159,3.159,0,0,0-3.045,1.5c.017.037,1.889-1,6.016,1.995a21.9,21.9,0,0,0,11.416,4.247c-6.06-2.35-9.005-3.766-12.163-8.67a23.393,23.393,0,0,1,16.674-5.469c8.432.466,14.844,10.339,14.844,10.339C481.881,1075.444,473.39,1066.708,457.473,1073.124Z",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M473.289,1069.1a24.679,24.679,0,0,0-16.1.465s9.416-1.773,15.751.649,8.9,5.086,8.9,5.086A17.475,17.475,0,0,0,473.289,1069.1Z",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M470.922,1074.95c-13.733-1.391-17.823,6.356-17.823,6.356a24.712,24.712,0,0,1,17.384-5.407c7.779.739,14.134,10.277,14.134,10.277S481.165,1075.988,470.922,1074.95Z",
    fill: "#391b13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M488.111,1109.247s9.228,6.155,11.287,5.884,10.62-5.875,10.62-5.875Z",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M499.093,1100.1c-5.81.16-7.455,1.633-7.029,3.185,1.039,3.771,3.506,4.48,7.138,4.469,3.823-.012,6.8-.856,7.393-4.92C506.769,1101.631,504.916,1099.936,499.093,1100.1Z",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M503,1110.235s6.067-4.538,7.227-3.357C513.679,1110.4,503,1110.235,503,1110.235Z",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M495.834,1110.226s-6.428-3.945-7.685-2.876C484.581,1110.386,495.834,1110.226,495.834,1110.226Z",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M488.111,1109.247s-.62-1.556,1.807-1.4c1.755.113,3.159,3.845,9.408,3.666,6.672-.191,7.582-3.544,9.3-3.635a1.211,1.211,0,0,1,1.4,1.375s3.163-1.636,1.967-3.1c-2.174-2.66-2.838,2.8-12.8,2.664-10.817-.155-12.052-5.445-13.522-2.051C485.057,1108.163,486.21,1108.577,488.111,1109.247Z",
    fill: "#f0c499"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M533.682,1067.563c-17.9,0-21.169,10.714-21.539,18.61a56.044,56.044,0,0,1,5.438,1.383c3.592,1.109,7.8,2.888,13.873,2.83,4.778-.041,15.476-2.484,15.624-12.763C547.2,1069.492,538.005,1067.921,533.682,1067.563Z",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M512.955,1085.557c3.908.558,6.516,1.9,9.23,2.63-2.114-1.947-3.334-3.71-3.175-6.921.143-2.778,2.26-5.811,4.064-7.488C516.739,1077.521,512.955,1085.557,512.955,1085.557Z",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M512.955,1085.557a30.958,30.958,0,0,1,6.219-5.175,8.862,8.862,0,0,1,3.376-5.437C516.756,1077.762,512.955,1085.557,512.955,1085.557Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M536.92,1082.179c-.17,3.339-1.929,5.43-4.375,7.049,10.453-1.36,14.13-9.071,14.13-9.071-6.458-5.36-11.81-7.614-16.219-8.007A9.957,9.957,0,0,1,536.92,1082.179Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M519.154,1080.153a9.94,9.94,0,0,0-.144,1.113c-.234,3.108.969,5.047,3.175,6.921.739.359,7.289,1.694,11.3,1.027,2.562-1.578,4.413-3.591,4.6-6.825a9.487,9.487,0,0,0-.937-4.722A20.118,20.118,0,0,0,519.154,1080.153Z",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M533.459,1074.13a8.972,8.972,0,0,1,4.225,5.054,26.519,26.519,0,0,1,6.065,3.506l1.24-2.273C542.442,1077.188,538.1,1074.993,533.459,1074.13Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M533.459,1074.13a22.931,22.931,0,0,0-8.417-.037,9.9,9.9,0,0,0-2.492.852,8.687,8.687,0,0,0-3.437,5.437,21.106,21.106,0,0,1,8.884-2.866,20.653,20.653,0,0,1,9.74,1.69A8.731,8.731,0,0,0,533.459,1074.13Z",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M528.826,1074.7a5.809,5.809,0,1,0,5.561,6.234A5.9,5.9,0,0,0,528.826,1074.7Z",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M529.859,1078.12a1.715,1.715,0,0,0-2.3.641,1.63,1.63,0,0,0,.549,2.274,1.713,1.713,0,0,0,2.3-.64A1.632,1.632,0,0,0,529.859,1078.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M535.259,1080.531a2.227,2.227,0,0,0-3.068.779,2.263,2.263,0,0,0,.825,3.079,2.22,2.22,0,0,0,3.066-.773A2.273,2.273,0,0,0,535.259,1080.531Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M550.711,1072.824a12.49,12.49,0,0,1-10.613-.319c-15.917-6.416-24.407,2.32-27.143,13.052,0,0,6.411-9.873,14.843-10.339a23.4,23.4,0,0,1,16.675,5.469c-3.159,4.905-6.1,6.321-12.164,8.671a21.9,21.9,0,0,0,11.416-4.248c4.128-2.992,6-1.957,6.016-1.995a3.159,3.159,0,0,0-3.044-1.5,6.635,6.635,0,0,0,.156-.663C551.453,1079.351,550.669,1073.06,550.711,1072.824Z",
    fill: "url(#linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M524.282,1068.483a17.479,17.479,0,0,0-8.556,6.2s2.57-2.664,8.9-5.087,15.752-.648,15.752-.648A24.676,24.676,0,0,0,524.282,1068.483Z",
    fill: "url(#linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M526.649,1074.331c-10.242,1.038-13.694,11.226-13.694,11.226s6.355-9.538,14.133-10.277a24.716,24.716,0,0,1,17.385,5.407S540.383,1072.94,526.649,1074.331Z",
    fill: "#391b13"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M556.811,1093.163s-1.7-7.188-7.641-10.208c10.552,17.478.772,38.611-9.671,48.075-11.525,10.447-13.306,13.814-17.359,17.917,0,0,15.566-14.2,20.59-17.818C546.757,1128.223,560.36,1113.122,556.811,1093.163Z",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M444.995,1084.484s-7.2,30.121,15.021,47.424c12.235,9.526,17.038,16.659,19.016,18.349-3.8-3.02-14.478-12.388-22.734-18.424C452.287,1128.9,432.775,1114.977,444.995,1084.484Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M481.953,1152.527s15.956,19.162,36.757-.43C518.71,1152.1,499.991,1166.867,481.953,1152.527Z",
    fill: "url(#linear-gradient-79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M500.568,1143.36c-4.3-.23-7.939.847-8.107,2.411s3.168,3.032,7.477,3.264,7.926-.846,8.1-2.418S504.862,1143.589,500.568,1143.36Z",
    fill: "url(#linear-gradient-80)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M561.261,1071.59c-.008-.651.421-5.126-1.626-5.115s-34.1.874-39.183,1.442c-9.593,1.07-14.943,5.08-15.963,5.29a106.855,106.855,0,0,1-11.376.062c-1.029-.2-6.65-4.143-16.3-5.113-5.108-.511-37.939-1.023-39.984-1.012s-1.21,4.5-1.178,5.138c.074,1.5,2.061,1.615,3.126,3.037s5.72,20.5,9.882,22.915,26.709,6.687,34.318.936,8.357-18.587,11.573-20.439,4.887-1.871,8.214-.052,5.192,14.672,13.133,20.335,30.155,1.248,34.172-1.221,7.264-21.693,8.246-23.126S561.277,1072.769,561.261,1071.59Zm-80.772,26.373c-8.074,3.712-28.393.876-30.951-2.574s-7.41-18.487-3.2-21.565,23.463-2.624,28.385-2.241,12.048,2.487,13.463,4.719C490.115,1079.349,488.572,1094.252,480.489,1097.963Zm68.531-3.025c-2.36,3.478-22.427,6.467-30.715,2.84s-10.991-18.534-9.238-21.6c1.282-2.243,8.244-4.432,13.143-4.863s24.122-2.466,28.5.569S551.373,1091.459,549.02,1094.938Z",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M468.32,1192.652c-3.16-1.536-13.446-8.891-13.446-8.891l-17.516,16.278,8.323,31.141L468.734,1202s26.022,13.149,31.372,18.192C500.106,1220.195,477.874,1197.3,468.32,1192.652Z",
    fill: "url(#linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M500.106,1220.195s-28.6-24.04-30.724-24.048-10.439,8.139-10.439,8.139S454,1213.84,440.9,1231.18c0,0-7.338-33.252-4.787-37.334,12.386-19.817,21.32-24.948,21.32-24.948a33.773,33.773,0,0,0,13.345,20.593C474.436,1192.171,494.564,1208.8,500.106,1220.195Z",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M535.946,1185.884s-30.677,26.614-35.84,34.311c0,0,30.809-19.447,33.639-19.094l19.71,28.486,8.325-32.026Z",
    fill: "url(#linear-gradient-84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M500.106,1220.195s30.356-25.464,32.479-25.464,8.139,6.37,8.139,6.37,13.416,20.171,18.37,26.54c0,0,6.76-31.264,4.277-35.388-11.123-18.476-22.465-24.821-22.465-24.821s-1.244,13.852-10.443,21.637C527,1192,500.816,1217.01,500.106,1220.195Z",
    fill: "url(#linear-gradient-85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M520.772,1294.032,562.784,1186s16.5,29.008,22.006,30.508c0,0-19.505,3.5-25.507,3.5l22.007,17.5s-65.992,63.575-67.255,105.309Z",
    fill: "url(#linear-gradient-86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M409.939,1371.584s6.461-49.056.571-120.346c0,0,8.729,21.984,14.438,35.645S409.939,1371.584,409.939,1371.584Z",
    fill: "url(#linear-gradient-87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M476.76,1305.035,437.228,1187.18s-16.885,28.787-22.406,30.214c0,0,19.458,3.759,25.459,3.839l-22.236,17.212s54.927,60.591,65.859,106.187Z",
    fill: "url(#linear-gradient-88)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M428.782,1484.183s2.692,91.956-4.389,94c-5.442,1.571-35.166-9.114-47.644-13.767.633-27.735,3.715-67.012,6.353-90.436Z",
    fill: "url(#linear-gradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M382.823,1476.5c.094-.985.256-2.041.3-2.815,12.935,2.241,36.71,6.823,45.675,10.687C428.8,1484.371,399.518,1482.038,382.823,1476.5Z",
    fill: "url(#linear-gradient-90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M543.873,1482.542s7,91.725,14.259,93.014c5.578.991,33.392-11.94,45.31-17.883-4.9-30.243-10.121-57.261-15.818-89.262Z",
    fill: "url(#linear-gradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M587.994,1470.476c-.164-.938-.4-2.1-.541-3.015-12.629,3.59-35.071,10.482-43.58,15.268C543.873,1482.729,571.973,1477.742,587.994,1470.476Z",
    fill: "url(#linear-gradient-92)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M416.954,1768.419s18.985,4.063,27.534,3.972l21.675-230.483Z",
    fill: "url(#linear-gradient-93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M549.412,1772.391s21,.091,26.981-1.076L526.5,1528.91S540.446,1688.952,549.412,1772.391Z",
    fill: "url(#linear-gradient-94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M544.939,1387.8c13.38,2.132,12.31,1.28,29.03,4.783l3.163-19.745H520.618l-5.029,2.911,1.235,21.34S531.513,1390.691,544.939,1387.8Z",
    fill: "url(#linear-gradient-95)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M543.376,1347.338s-41.53,1.122-55.086.324c-16.839-.991-63.245-8.032-76.5-2.628s-30.835,42.9-8.838,45.93,93.773-4.738,140.373-15.044Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M548.929,1367.947c.432-.135,1.738,2.882,3.043,2.714a13.251,13.251,0,0,0-.547,2.807,14.5,14.5,0,0,0-.01,2.243c-9.938.666-18.99,2.668-27.214,4.437-15.456,3.328-59.459,8.959-59.459,8.959l-1.914-5.211C465.441,1384.058,545.672,1368.955,548.929,1367.947Z",
    fill: "url(#linear-gradient-96)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M403.854,1385.886l-6.022,19.374s34.564.377,81.857-5.893c.645-5.851,1.626-18.65,1.626-18.65Z",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M398.77,1196.4c-5.061,1.842-7.229,6.219-9.2,26.3s.53,39.758.01,47.795-4.88,45.07-5.54,68.736-.413,45.108,5.8,49.631,48.176,7.141,56.22,6.768,75.534-5.117,75.534-5.117l.363-39.752s-84.314-11.489-87.889-11.522-3.015-61.221-3.847-67.929-1.842-29.329-6.627-43.665C417.425,1209.143,405.895,1193.8,398.77,1196.4Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M392.783,1203.355c9.167-24.314,14.764,71.708,11.364,80.684-4.586,12.1-13.74-1.073-14.938-25.262C388.531,1245.221,387.445,1217.528,392.783,1203.355Z",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M480.334,1320.027l-.251,11.926s-22.041-1.209-23.813-2.565-27.874-29.064-27.874-29.064l.756-9.6s27.252,24.146,30.13,26.851S480.334,1320.027,480.334,1320.027Z",
    fill: "url(#linear-gradient-99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M431.688,1305.157s-3.425-65.925-5.7-77.089c-1.886-9.281-6.686,57.3-6.686,57.3Z",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M516.422,1321.227l.587,8.941s41.3,2.163,42.641,1.728,17.215-26.421,17.466-29.546-2.588-9.849-2.588-9.849-13.024,25.542-15.888,27.548C555.493,1322.252,525.127,1321.531,516.422,1321.227Z",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M386.576,1330.975s4.415.911,12.693-5.729c0,0,10.628,4.363,14.657,4.4,0,0,4.67,7.864,6.076,9.063s-15.861,24.269-9.188,20.064,12.661-10.554,16.685-10.044,14.67,2.745,18.939,2.308,18.657,7.52,18.657,7.52l8.744,3.487-.737,7.028,48.616,9.343.632-13.28s-64.811-35.327-69.3-37.5-50.217-55.687-51.156-56.644l-.939-.956s-3.111,3.055,1.8,9.972a144.75,144.75,0,0,0,9.615,11.228s-24.415,4.23-25.387,6.471c-.2.462-.442,4.715-.442,4.715a19.854,19.854,0,0,0,9.409-3.908c.7-.534,2.918.657,7.657.621.718,0,2.8,5,10.756,7.922,7.621,2.8-14.447-1.712-16.349-1.02s-12.4,7.063-12.4,7.063l-.41,5.217s5.9.537,13.7-6.107c.751-.643,6.441,3.93,16.452,6.628s-15.083-.929-17.705.707S385.4,1329.544,386.576,1330.975Z",
    fill: "url(#linear-gradient-102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M460.313,1328.647l82.569,8.178-2.066,36.01-84.155-24.628Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M438.489,1265.448s13.952,58.789-22.543,60.435c0,0-1.9,3.152,3.377,3.315s34.98-7.873,23.065-64.567Z",
    fill: "url(#linear-gradient-103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M420.741,1270.477s17.076,57.962,49.573,41.27c0,0,3.213,1.792-1.286,4.556s-34.27,10.534-52.074-44.6Z",
    fill: "url(#linear-gradient-104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M467.533,1313.149s3.369-3.6,4.512-3.07,2.782,4.975,2.31,5.7-4.067,1.114-5.471.854A13.93,13.93,0,0,1,467.533,1313.149Z",
    fill: "#022d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M441.027,1172.375c-20.319,15.317-24.108,47.853-21.947,62.562-13.646,6.884-2.959,38.435-2.5,38.627s5.161-1.37,5.506-2-12.246-29.978.1-32.206c13.532-2.44,15.626,28.67,15.878,29.166s5.99-.4,6.336-1.026-5.1-33.046-21.307-33.257c-1.6-12.186-.516-37.026,14.726-53.809C437.977,1179.637,441.252,1172.976,441.027,1172.375Z",
    fill: "#023c74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M546.54,1283.845a16.319,16.319,0,1,0,16.534-16.194A16.363,16.363,0,0,0,546.54,1283.845Z",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M548.6,1283.314a14.636,14.636,0,1,0,14.828-14.524A14.675,14.675,0,0,0,548.6,1283.314Z",
    fill: "url(#linear-gradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M567.7,1268.012c8.635-41.436,12.533-86.822-13.788-95.637a23.667,23.667,0,0,0,2.126,5.627c21.006,12,11.728,69.847,7.476,89.584-.4,1.958-1.946,4.284-1.67,6.82s3.59,3.5,4.861,1.406S567.367,1269.51,567.7,1268.012Z",
    fill: "#023c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M555.674,1283.074a9.311,9.311,0,1,0,8.635-10.027A9.36,9.36,0,0,0,555.674,1283.074Z",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M557.722,1282.163a7.949,7.949,0,1,0,7.376-8.376A7.918,7.918,0,0,0,557.722,1282.163Z",
    fill: "url(#linear-gradient-108)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M544.008,1159s10.868,3.388,13.775,10.992c6.5,17.005,22.109,41.059,23.571,41.662,0,0-16.418,5.37-25.724,2.214,0,0,18.052,14.3,21.8,18.067,0,0-28.8,33.776-39.153,45.587s-22.944,53.857-24.242,65.3a444.162,444.162,0,0,1,4.123-51.854c3.773-25.3,10.98-42.35,19.661-73.329C543.5,1197.363,553.68,1165,544.008,1159Z",
    fill: "url(#linear-gradient-109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M457.78,1158.98s-12.808,3.366-15.854,10.916c-6.81,16.883-22.8,40.648-24.273,41.224,0,0,16.317,5.67,25.678,2.685,0,0-18.31,13.964-22.127,17.665,0,0,24.916,31.557,35.049,43.556s25.22,57.006,26.311,68.469a444.791,444.791,0,0,0-3.176-51.92c-3.31-25.37-10.2-42.544-18.317-73.676C455.761,1197.52,448,1164.8,457.78,1158.98Z",
    fill: "url(#linear-gradient-110)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M466.827,1330.948s-19.569-13.981-24.8-21.648-15.517-18.245-17.922-21.711-22.033-20.3-23.818-18.269,3.844,9.7,10.052,14.361c2.011,4.06,13.1,15.02,13.1,15.02s-12.494-7.634-15.553-9.709c-2.085-1.411-10.929.3-13.8.6s-11.574,8.332-10.12,10.544c1.384,2.1,4.431.1,11.867-3.984,2.625.873,6.2,1.091,8.446.04,1.929,4,8.152,8.018,8.152,8.018s-11.942-2.611-16.314-.973-14.2,11.371-13.8,12.043c2.254,3.7,11.481-1.032,16.742-5.7l14.772,6.815s-13.012-.542-15.907.233-11.3,9.887-13.689,12.57c1.691,3.356,3.58,2.068,15.268-6.873,0,0,9.5,3.561,15.558,5.292,0,0,14.033,18.522,27.353,18.716,9.613.144,20.848,4.287,20.848,4.287Z",
    fill: "url(#linear-gradient-111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M445.132,1346.468a77.885,77.885,0,0,1,23.064,2.353c12.544,3.2,53.508,15.669,53.508,15.669s-4.627,6.35-7.345,5.486c-10.041-3.2-18.349-5.06-32.609-11.637C466.241,1351.183,449.382,1346.954,445.132,1346.468Z",
    fill: "url(#linear-gradient-112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M522.939,1333.383s-38.98-1.165-60.492-6.209c-2.84-.667-21.373-20-28.931-28.4-4.633-5.142-19.916,20.982-2.76,27.278s26.99,6.492,36.934,8.115c12.3,2.007,54.18,8.209,54.18,8.209Z",
    fill: "url(#linear-gradient-113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M427.7,1300.736l-4.263-2.035s-10.947-10.4-13.1-15.02c0,0-9.934-6.577-10.391-13.389a62.528,62.528,0,0,0,11.172,12.52C417.608,1288.13,427.7,1300.736,427.7,1300.736Z",
    fill: "url(#linear-gradient-114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M421.127,1306.6s-14.627-10.936-15.154-11.694-10.038-.228-10.546-.155-7.822,5.584-11.459,5.384c0,0,.657,1.524,3.688.73a23.85,23.85,0,0,0,7.991-4.264s4.887,1.252,8.676.006c0,0,1.756,4.21,8.071,7.578Z",
    fill: "url(#linear-gradient-115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M420.918,1316.673l-7.081-.278s-10.7-3.509-14.772-6.815c0,0-10.5,9.017-15.51,6.738,0,0,5.157-.806,15.437-8.325C398.992,1307.993,416.431,1314.973,420.918,1316.673Z",
    fill: "url(#linear-gradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M417.991,1325.692s-17.679-4.865-18.646-5.038-7.788,7.811-13.494,10.19c0,0,2.6,1.272,13.206-7.854,0,0,10.4,4.539,16.01,4.627,0,0,14.2,21.57,30.268,18.853C445.335,1346.47,428.812,1346.651,417.991,1325.692Z",
    fill: "url(#linear-gradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M406.483,1272.061c.343.336-.181,2.412-2.77.712s-3.114-2.517-3.249-2.879.117-2.806,1.49-1.813A44.954,44.954,0,0,1,406.483,1272.061Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M387.14,1293.777c.379-.294,2.364.509.325,2.842s-2.919,2.74-3.3,2.824-2.764-.5-1.592-1.724A44.8,44.8,0,0,1,387.14,1293.777Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M386.133,1310.5c.38-.293,2.365.509.326,2.842s-2.919,2.74-3.3,2.824-2.764-.5-1.592-1.724A44.921,44.921,0,0,1,386.133,1310.5Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M387.906,1325.346c.338-.262,2.108.454.29,2.535s-2.6,2.444-2.939,2.519-2.466-.446-1.421-1.538A40,40,0,0,1,387.906,1325.346Z",
    fill: "#ffdebd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M473.981,1355.022l2.775-25.3,8.64,1.06-3.306,27.628Z",
    fill: "url(#linear-gradient-118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M581.337,1256.148s-.17-30.362.733-31.695,11.606-37.868,23.911-33.123c7.121,2.745,8.9,10.2,11.816,33.9.71,5.781,3.11,56.326,2.556,62.553-1,11.162,9.871,93-3.113,96.454-19.253,5.122-135.64-16.424-140.537-17.81l3.938-40.163s86.875,6.919,94.465,6.988S581.337,1256.148,581.337,1256.148Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M598.338,1329.2a85.285,85.285,0,0,0-20.6-2.322c9.528-4.653,9.8-8.681,9.8-8.681l-6.647,1.361c12.65-9.839,10.107-16.973,10.107-16.973,4.768-3.039,3.4-8.505,3.4-8.505l-7.61,2.541c3.123-4.239.516-9.595.516-9.595l-26.655,43.25s14.615.359,15.283.377c7.462.543,13.19,4.553,15.943,6.309,3.771,2.4,9.279,10.721,7.563,2.438a12.709,12.709,0,0,0-5.563-8.551C599.282,1330.73,602.41,1330.29,598.338,1329.2Z",
    fill: "url(#linear-gradient-119)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M585.4,1286.025c-1.5-.054-5.77,7.843-12.518,14.157-1.308,1.224-6.629,14.453-8.594,20.62l11.184-13.025S593.5,1286.312,585.4,1286.025Z",
    fill: "url(#linear-gradient-120)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M580.524,1301.623s8.427-11.054,6.772-14.6c0,0-4.879,11.3-13.475,19.562Z",
    fill: "url(#linear-gradient-121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M559.047,1329.051c3.536-6.247,10.891-19.366,13.757-21.819,7.223-6.189,20.054-17.531,21.416-15.622,3.782,5.292-16.533,18.321-18.99,20.933-1.727,1.835-7.368,11.211-10.795,16.912C562.771,1329.294,560.682,1329.211,559.047,1329.051Z",
    fill: "url(#linear-gradient-122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M594.581,1292.342s1.869,3.954-9.524,12.769l-4.764,2.694S590.668,1299.458,594.581,1292.342Z",
    fill: "url(#linear-gradient-123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M557.836,1329.271c3.185-3.2,12.952-14.748,14.2-15.622,12.247-8.569,19.25-14.584,20.161-12.656,1.109,2.352.839,5.08-16.691,18.148-4.77,4.953-4.689,7.335-7.774,10.423C564.369,1329.414,561.071,1329.543,557.836,1329.271Z",
    fill: "url(#linear-gradient-124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M592.531,1301.983s.8,2.356-3.863,6.685c-4.852,4.511-13.164,10.473-13.164,10.473l-2.454,3.345-4.3,2.6,6.247-7.934S591.091,1306.7,592.531,1301.983Z",
    fill: "url(#linear-gradient-125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M575.453,1326.85c1.922-1.406,14.927-7.015,12.837-10.838-.845-1.549-16.674,4.116-24.922,13.53l8.772.319A13.642,13.642,0,0,1,575.453,1326.85Z",
    fill: "url(#linear-gradient-126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M581.518,1290.7c-.2.349.707,1.9,2.393-.073s1.918-2.749,1.943-3.071-.749-2.229-1.621-1.111A37.379,37.379,0,0,0,581.518,1290.7Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M588.408,1294.55c-.3.273.092,2.023,2.3.663s2.666-2.031,2.788-2.33-.031-2.351-1.2-1.554A37.749,37.749,0,0,0,588.408,1294.55Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M586.52,1303.516c-.315.25-.06,2.024,2.244.834s2.812-1.824,2.956-2.114.146-2.347-1.083-1.639A37.541,37.541,0,0,0,586.52,1303.516Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M582.941,1317.027c-.312.173.019,2.13,2.334,1.535s2.809-1.12,2.945-1.385.057-2.448-1.174-2.054A25.09,25.09,0,0,0,582.941,1317.027Z",
    fill: "#ffdebd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M612.869,1198.771c2.254,6.679,7.94,30.473,5.276,75.724-1.677,28.492-14.973,30.439-16.362,26.636S605.484,1176.9,612.869,1198.771Z",
    fill: "url(#linear-gradient-127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M480.708,1324.811s83.269,3.124,98.417,5.629-5.326,21.127-20.253,20.28-79.527-10.846-79.527-10.846Z",
    fill: "url(#linear-gradient-128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M622.481,1324.417s1.2,15.1,1.532,27.274c.437,15.825.354,28.411-5.431,32.333-8.82,5.98-57.3-3.941-92.542-8.73,0,0,58.339,2.837,71.176-1.312S621.4,1338.747,622.481,1324.417Z",
    fill: "url(#linear-gradient-129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M384.065,1338.3s-2.6,47.827,6.368,52.175,38.278,6.024,53.934,5.16c0,0-23.56-8.675-37.244-15.911S383.948,1351.1,384.065,1338.3Z",
    fill: "url(#linear-gradient-130)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginpagedoctors02);
export default __webpack_public_path__ + "static/media/login page doctors 02.d5d726226b3fb010a8b0f0f7663b99c7.svg";
export { ForwardRef as ReactComponent };